var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderPackingDetail',{attrs:{"label":"Restock","with-fee":false,"pengemasan-path":"gudang.pengeluaran.barang-ke-kp.pengemasan","index-path":{ name: 'gudang.pengeluaran.barang-ke-kp' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }